export const SET_LOADING = 'SET_LOADING'
export const SET_GRID_LOADING = 'SET_GRID_LOADING'
export const SET_TEMPLATES_LOADING = 'SET_TEMPLATES_LOADING'
